<template>
  <span v-if="notifications" class="badge-count">
    {{ notifications > 99 ? '99+' : notifications }}
  </span>
</template>

<script>
export default {
  name: 'BadgeCount',
  props: {
    notifications: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-count {
  background: var(--text-primary, #0b182c);
  color: var(--text-inverse, #ffffff);
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  min-width: 20px;
  padding: 1px 0;
  border-radius: 9999px;

  &.inline {
    display: inline-flex;
    margin-left: 0;
    padding: 1px 4px;

    &.left-auto {
      margin-left: auto;
    }

    @media ($desktop) {
      padding: 10px 7px;
      &.left-5x {
        margin-left: 5px;
      }
    }
  }

  &.absolute {
    position: absolute;
    top: calc(20% - 4px);
    left: calc(50% + 13px);
    transform: translateX(-50%);
    padding: 1px 4px;
  }
}
</style>
